var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_4056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.53 29.8507H81.066V8.06638C81.0659 7.30369 80.7629 6.57226 80.2236 6.03296C79.6843 5.49366 78.9529 5.19064 78.1902 5.19055H28.2158C27.8381 5.1905 27.4641 5.26486 27.1152 5.40936C26.7662 5.55387 26.4492 5.7657 26.1821 6.03276C25.9151 6.29981 25.7032 6.61686 25.5587 6.96579C25.4142 7.31473 25.3399 7.68871 25.3399 8.06638V29.8507H2.87583C2.49817 29.8507 2.12419 29.925 1.77527 30.0695C1.42635 30.2141 1.10931 30.4259 0.842258 30.6929C0.575207 30.96 0.363376 31.277 0.218861 31.626C0.0743451 31.9749 -2.39579e-05 32.3489 2.31944e-08 32.7265V46.5593C-4.79445e-05 46.937 0.0743048 47.3109 0.218812 47.6599C0.363319 48.0088 0.575149 48.3259 0.842204 48.5929C1.10926 48.86 1.42631 49.0718 1.77524 49.2163C2.12418 49.3608 2.49816 49.4352 2.87583 49.4351H4.05876V94.3441C4.05871 94.7218 4.13306 95.0958 4.27757 95.4447C4.42208 95.7937 4.63391 96.1107 4.90096 96.3778C5.16802 96.6448 5.48507 96.8567 5.834 97.0012C6.18294 97.1457 6.55692 97.22 6.93459 97.22H99.4721C100.235 97.2199 100.966 96.9169 101.506 96.3776C102.045 95.8383 102.348 95.1068 102.348 94.3441V49.4343H103.529C104.292 49.4342 105.023 49.1311 105.562 48.5918C106.102 48.0525 106.405 47.3211 106.405 46.5585V32.7257C106.405 32.3482 106.331 31.9743 106.186 31.6255C106.042 31.2767 105.83 30.9597 105.563 30.6927C105.296 30.4257 104.979 30.214 104.63 30.0695C104.281 29.925 103.908 29.8507 103.53 29.8507ZM100.654 35.6024V43.6834H81.066V35.6024H100.654ZM85.3643 73.6535V67.9018H91.9788V73.6535H85.3643ZM91.9796 80.5229V86.2745H85.3652V80.5229H91.9796ZM85.3643 61.0324V55.2807H91.9788V61.0324H85.3643ZM75.3143 10.9422V13.5792H31.0916V10.9422H75.3143ZM14.426 73.6535V67.9018H21.0404V73.6535H14.426ZM21.0415 80.5229V86.2745H14.4271V80.5229H21.0415ZM14.426 61.0324V55.2807H21.0404V61.0324H14.426ZM5.75167 35.6024H25.3408V43.6834H5.75167V35.6024ZM31.0916 91.4675V19.3309H75.3143V91.4675H31.0916Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7119 24.219H69.4636V37.2435H63.7119V24.219Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3271 24.219H56.0788V37.2435H50.3271V24.219Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9404 24.219H42.6921V37.2435H36.9404V24.219Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7119 48.5264H69.4636V61.5512H63.7119V48.5264Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3271 48.5264H56.0788V61.5512H50.3271V48.5264Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9404 48.5264H42.6921V61.5512H36.9404V48.5264Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7119 72.8341H69.4636V85.8586H63.7119V72.8341Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3271 72.8341H56.0788V85.8586H50.3271V72.8341Z",
    fill: "#2B3674"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9404 72.8341H42.6921V85.8586H36.9404V72.8341Z",
    fill: "#2B3674"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_4056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.405,
    height: 106.405,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.4c8cb237706dbb681a0bf88433b1bd7b.svg";
export { ForwardRef as ReactComponent };